import { getHistoricalData } from "@/_core/data/api_calls/candle_data/getHistoricalData";
import { formatDate_YMDHMS, roundDateToFloor } from "@/_core/_helpers/_helpers";
import gql from "graphql-tag";

/**
 * Retrieves historical data + technical analysis for interest rates
 * @param {object} _this: context variables
 * @param {object} assetExtraParams: Contains commodity information related
 */
export function getCandleInterestRate(_this, assetExtraParams) {
  const params = gql`
    query($format: String, $interest_rate: Int, $observation_date: String) {
      interest_rate_historical(
        format: $format
        observation_date: $observation_date
        interest_rate: $interest_rate
      ) {
        observation_date
        open
        high
        low
        close
        settle
        expiration_date
        days_to_expiration
        term
        fk_idinterestrate
        fk_iddatasource
      }
    }
  `;
  const variables = {
    format: "json",
    observation_date: formatDate_YMDHMS(
      roundDateToFloor(assetExtraParams.initDate)
    ),
    interest_rate: assetExtraParams.interest_rate
  };
  return getHistoricalData(_this, {
    params,
    variables,
    source: "interest_rate_historical"
  });
}
